import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import SendIcon from '@material-ui/icons/Send';
import FullscreenIcon from '@material-ui/icons/Fullscreen';
import withWidth from '@material-ui/core/withWidth';
import CircularProgress from '@material-ui/core/CircularProgress';
import green from '@material-ui/core/colors/green';

const styles = {
    root: {
        flexGrow: 1,
    },
    grow: {
        flexGrow: 1,
    },
    menuButton: {
        marginLeft: -12,
        marginRight: 20,
    },
    message: {
        padding: '20px 0 0px 0', 
        color: 'rgba(0, 0, 0, 0.87)',
        fontSize: '.9rem',
        fontWeight: '400',
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        lineHeight: '1.46429em',
    },
    buttonProgress: {
        color: green[500],
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -15,
        marginLeft: -15,
    },
};


const inIframe = () => {
    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
};

const openInFullWindowMode = () => {
    window.parent.location = window.location;
}


export class Banner extends Component {
    render() {
        const { classes } = this.props;
        const { width } = this.props;


        return (            
            <div className={classes.root}>
                <AppBar position="fixed">
                    <Toolbar>       
                        <div className="logo">&nbsp;</div>
                        <Typography variant="h6" color="inherit" className={classes.grow}>                           
                            {width !== 'xs' && "Schaumburg "} Vacation Watch
                        </Typography>
                        <div style={{ display:'flex' }}>                           
                            <div style={{ position: 'relative'}}>
                                    {width === 'xs' && <Button variant="contained" size="medium"  color="secondary" onClick={this.props.onCreate}  disabled={this.props.disabled || this.props.working}>
                                        Submit
                                    </Button>}  
                                    {width !== 'xs' && <Button variant="contained" size="medium" color="secondary" onClick={this.props.onCreate} disabled={this.props.disabled || this.props.working}>
                                    Submit Request <SendIcon style={{marginLeft:'5px'}} />
                                    </Button>}  
                                    {this.props.working && <CircularProgress size={30} className={classes.buttonProgress} />}
                            </div>                            
                        </div>
                    </Toolbar>
                </AppBar>
                {!inIframe() && <div className="container container-fluid">
                    <div className={classes.message}>    
                        <Card>
                            <CardContent>
                                
                                <Typography
                                    variant="h6"
                                >
                                    Village of Schaumburg
                                </Typography> 

                                <Typography variant="body1">
                                    A vacation watch alerts your area beat officer that you will be on vacation during the specified time period. The officers will do extra patrols at your property when time permits checking the exterior only of your property. There is no guarantee on the timing or frequency of these checks as they are dependent on the officers call volume and other assignments. Should an incident occur at your location while you are away, the vacation watch system gives public safety responders a method to contact you or a representative of your choice. 
                                </Typography>

                            </CardContent>
                        </Card>
                    </div>
                </div>}

                {inIframe() && <div className="container container-fluid">  
                    <div className={classes.message}>    
                        <Typography variant="subtitle1">
                            Open in fullscreen mode <Button variant="fab" mini onClick={openInFullWindowMode}><FullscreenIcon /></Button> for a better user experience if using a smaller screen or mobile device.
                          </Typography>
                    </div>
                    </div>} 
            </div>
        );
    }
}

Banner.propTypes = {
    classes: PropTypes.object.isRequired,
    width: PropTypes.string.isRequired,
};

export default withWidth()(withStyles(styles)(Banner));


// WEBPACK FOOTER //
// ./src/components/Banner.jsx